import type { Filter, FilterDataMultiSelect } from '@/app/common/filters/core/filtersTypes.ts';
import { FILTER_TYPE } from '@/app/common/filters/core/filtersTypes.ts';

const MIN_OPTIONS_FOR_TWO_COLUMNS = 6;

export enum SLOT {
  PILLS = 'PILLS',
  ALL_FILTERS = 'ALL_FILTERS',
  MODAL = 'MODAL',
  MOBILE_MODAL = 'MOBILE_MODAL',
}

export type ColumnOverride = {
  filterNames: string[];
  columns: number;
  slot?: SLOT;
};

const getMultiSelectOptionsCount = (filters: Filter[]): number => {
  const multiSelect = filters.find((filter) => filter.type === FILTER_TYPE.MULTI_SELECT);
  return multiSelect ? (multiSelect.data as FilterDataMultiSelect).options.length : 0;
};

const getDefaultColumns = (filters: Filter[], slot: SLOT): number => {
  if (slot === SLOT.MOBILE_MODAL) return 1;

  const type = filters.find((f) => f.type)?.type;
  const isMultiSelect = type === FILTER_TYPE.MULTI_SELECT;
  const isRadio = type === FILTER_TYPE.RADIO;

  if (slot === SLOT.ALL_FILTERS && (isMultiSelect || isRadio)) return 2;

  if (isMultiSelect && getMultiSelectOptionsCount(filters) < MIN_OPTIONS_FOR_TWO_COLUMNS) return 1;

  if ((slot === SLOT.PILLS || slot === SLOT.MODAL) && isMultiSelect) return 2;
  return 1;
};

const EVO_COLUMNS = 1;

export const getNumberOfColumns = (
  filters: Filter[],
  slot: SLOT,
  columnOverrides: ColumnOverride[] = [],
  useEvoFilters = false
): number => {
  const filterNames = new Set(filters.map((f) => f.name as string));

  const matchedOverride = columnOverrides.find((override) => {
    const slotMatches = override.slot === undefined || override.slot === slot;
    const filterMatches = override.filterNames.some((name) => filterNames.has(name));
    return slotMatches && filterMatches;
  });

  if (matchedOverride) return matchedOverride.columns;

  return useEvoFilters ? EVO_COLUMNS : getDefaultColumns(filters, slot);
};

export const getColumnRows = (
  filterName: string,
  optionsCount: number,
  columns: number,
  filtersWithRowLayout: string[] = []
): number | undefined => {
  const hasMultipleColumns = columns > 1;
  const hasOptions = optionsCount > 0;
  const usesRowLayout = filtersWithRowLayout.includes(filterName);

  if (!hasMultipleColumns || !hasOptions || usesRowLayout) return undefined;

  return Math.ceil(optionsCount / columns);
};
